import React from 'react';
import { FaCheck } from 'react-icons/fa';

const ProfileWizard = ({ currentStep, steps, onStepClick }) => (
    <div className="wizard-container">
        <div className="step-indicator-wrapper">
            <div className="step-progress-track"></div>
            <div className="step-progress-fill" style={{ width: `${(currentStep / (steps.length - 1)) * 92}%` }}></div>
            {steps.map((step, index) => (
                <div 
                    key={step.id} 
                    className={`step-item ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
                    onClick={() => onStepClick && onStepClick(index)}
                    style={{ cursor: 'pointer' }}
                >
                    <div className="step-circle">{index < currentStep ? <FaCheck /> : index + 1}</div>
                    <div className="step-label">{step.title}</div>
                </div>
            ))}
        </div>
    </div>
);

export default ProfileWizard;